var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.923.836c-4.996 0-9.06 3.938-9.06 8.78 0 4.84 4.064 8.779 9.06 8.779 4.995 0 9.06-3.938 9.06-8.78 0-4.84-4.065-8.779-9.06-8.779m0 18.395C4.45 19.23 0 14.917 0 9.615 0 4.314 4.451 0 9.923 0c5.47 0 9.922 4.314 9.922 9.615 0 5.302-4.451 9.616-9.922 9.616"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.51 13.22a.204.204 0 0 0-.208.2c0 .221.414.221.414 0 0-.11-.093-.2-.207-.2m0 .802a.612.612 0 0 1-.62-.601c0-.332.279-.601.62-.601.342 0 .62.269.62.6a.612.612 0 0 1-.62.602M9.51 12.018a.407.407 0 0 1-.414-.4v-.33c0-.797.487-1.518 1.24-1.836a2.002 2.002 0 0 0 1.24-1.836c0-1.105-.927-2.003-2.067-2.003-.552 0-1.072.208-1.462.587-.39.378-.605.88-.605 1.415 0 .222-.185.401-.414.401a.407.407 0 0 1-.413-.4c0-.75.301-1.454.848-1.984a2.925 2.925 0 0 1 2.045-.82h.001c1.596 0 2.894 1.258 2.894 2.804 0 1.115-.681 2.124-1.736 2.57a1.203 1.203 0 0 0-.744 1.102v.33c0 .22-.186.4-.414.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcon);
export default __webpack_public_path__ + "static/media/help-icon.4e8fe55305cdfe51820346d560f36e3d.svg";
export { ForwardRef as ReactComponent };